<template>
  <el-card>
    <template #header>
      <content-header />
    </template>

    <div class="header-button">
      <search-form
        ref="searchForm"
        :fields="search"
      />
    </div>

    <el-table
      :data="recharge_order"
      resource="recharge_order"
    >
      <!-- <el-table-column
        prop="id"
        label="ID"
        width="60"
        align="center"
      />-->
      <el-table-column
        prop="no"
        label="订单号"
        width="250"
        align="center"
      />
      <!-- <el-table-column
        show-overflow-tooltip
        width="250"
        prop="users"
        label="真实姓名"
      >
        <template #default="{ row }">
          {{ row.users.truename }}
        </template>
      </el-table-column> -->
      <el-table-column
        prop="users"
        width="150"
        align="center"
        label="手机号"
      >
        <template #default="{ row }">
          {{ row.users.mobile }}
        </template>
      </el-table-column>

      <el-table-column
        prop="deposit_card_name"
        label="名称"
        width="150"
        align="center"
      >
        <template slot-scope="scope">
          <el-tag type="warning">{{ scope.row.deposit_card_name }}</el-tag>
        </template>
      </el-table-column>

      <el-table-column
        prop="pay_money"
        label="支付金额"
        width="150"
        align="center"
      >
        <template slot-scope="scope">
          <el-tag type="danger">{{ scope.row.pay_money }}</el-tag>
        </template>
      </el-table-column>

      <!-- <el-table-column
              prop="discount"
              label="折扣"
              width="80"
              align="center"
            >
              <template slot-scope="scope">
                <el-tag v-if="scope.row.discount == 1">无折扣</el-tag>
                <el-tag v-else>{{ scope.row.discount * 10 }} 折</el-tag>
              </template>
            </el-table-column> -->

      <el-table-column
        prop="area"
        show-overflow-tooltip
        min-width="8%"
        align="center"
        label="区域"
      >
        <template #default="{ row }">
          <el-tag class="mr-1">
            {{ row.areas.name }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        label="支付状态"
        width="100"
        align="center"
      >
        <template slot-scope="scope">
          <el-tag
            v-if="scope.row.pay_status"
            type="success"
          >成功</el-tag>
          <el-tag
            v-else
            type="danger"
          >失败</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="created_at"
        label="添加时间"
        width="180"
        align="center"
      />

      <el-table-column
        prop="pay_time"
        label="支付时间"
        width="180"
        align="center"
      />
      <!-- <el-table-column label="操作" width="150">
              <template #default="{ row, $index }">
                <el-button-group>
                  <row-to-edit/>
                  <row-destroy/>
                </el-button-group>
              </template>
            </el-table-column> -->
    </el-table>
    <div class="card-footer">
      <pagination :page="page" />
    </div>
  </el-card>
</template>

<script>
import SearchForm from "@c/SearchForm";
import Pagination from "@c/Pagination";
import { getDepositCardOrders } from "@/api/deposit-cards";
import { getAreas } from "@/api/area";
import { mixinsAutoPageSize } from "@/libs/utils";
import { getAdminUsersMerchant } from "@/api/admin-merchant";
import env from "../../../env";

export default {
  name: "Index",
  components: {
    SearchForm,
    Pagination
  },
  data() {
    return {
      search: [
        {
          type: "el-select",
          field: "area_id",
          label: "骑行区域",
          options: [
            {
              id: "",
              name: "全部"
            }
          ]
        },
        {
          type: "super-input",
          field: "mobile_nickname",
          label: "用户手机号"
        },
        {
          field: "no",
          label: "订单号"
        },
        {
          type: "el-select",
          field: "pay_status",
          label: "是否支付成功",
          options: [
            {
              id: "",
              name: "全部"
            },
            {
              id: 1,
              name: "成功"
            },
            {
              id: 0,
              name: "失败"
            }
          ]
        }

        // {
        //   type: 'el-select',
        //   field: 'is_discount',
        //   label: '是否折扣',
        //   options: [
        //     {
        //       id: '',
        //       name: '全部',
        //     },
        //     {
        //       id: 1,
        //       name: '有折扣',
        //     },
        //     {
        //       id: 0,
        //       name: '无折扣',
        //     },
        //   ],
        // },
      ],
      recharge_order: [],
      page: null,
      first_blood: true
    };
  },
  async created() {
    const [{ data: areas }] = await Promise.all([getAreas({ all: 1 })]);

    this.search[0].options.push.apply(this.search[0].options, areas);
    if (this.$store.state.users.user.roles[0] === "administrator") {
      const [{ data: merchant }] = await Promise.all([
        getAdminUsersMerchant({ all: 1 })
      ]);
      if (env.isPosSwitch == true) {
        this.search.push({
          type: "el-select",
          field: "merchant_id",
          label: "商户",
          options: [
            {
              id: "",
              name: "全部"
            }
          ]
        });
        this.search[4].options.push.apply(
          this.search[4].options,
          merchant.data
        );
      }
    }
  },
  mixins: [mixinsAutoPageSize],
  watch: {
    $route: {
      async handler(newVal) {
        await this.autoPageSize(47, newVal);
        const {
          data: { data, meta }
        } = await getDepositCardOrders(newVal.query);
        this.recharge_order = data;
        this.page = meta;
      },
      immediate: true
    }
  }
};
</script>
<style lang="scss" scoped>
.header-button {
  display: flex;
  justify-content: space-between;

  .selections {
    display: inline-block;
    margin-right: 10px;
  }
}
</style>
